<template>
    <div class="quiz-bottom">
        <button
            type="button"
            class="quiz-bottom__save"
            :disabled="saving"
            :aria-busy="saving ? 'true' : 'false'"
            @click="$emit('save')"
        >
            <fa icon="fa-solid fa-paper-plane" />
            <span>{{ saving ? $t('admin.quiz.saving') : $t('admin.quiz.save') }}</span>
        </button>
    </div>
</template>

<script>
    export default {
        name: 'QuizBottomBar',
        props: {
            saving: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['save'],
    };
</script>
